import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import { LOGOUT } from 'ConstComponents';

import {
    Container,
    Grid,
    Button,
    Box,
    CircularProgress,
    Paper
} from '@material-ui/core';
import {
    InsertToken as INSERT_TOKEN,
    SelectToken as SELECT_TOKEN
} from 'Components/Api/UsersApi';
import { Send as SEND_OTP } from 'Components/Api/OTPAPI';
import { OTPModal } from 'Components/Modal/OTPModal';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const UserToken = () => {
    const classes = commonStyle();
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const [responseMessage, setResponseMessage] = useState('');

    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [openOTP, setOpenOTP] = useState(false);

    const [formObject, setFormObject] = useState({
        APIToken: '',
        MobileNumber: '',
    });

    useEffect(() => {
        select();
    }, []);

    const select = async () => {
        setLoadingOpen(true);

        setIsError(false);

        var response = await SELECT_TOKEN();
        if (!response.isAuthorized) {
            LOGOUT();
        }
        var data = JSON.parse(response.data);
        setFormObject({
            APIToken: data.APIToken,
            MobileNumber: data.MobileNumber,
        });
        setLoadingOpen(false);
    };

    const submitHandle = async (values, { setSubmitting }) => {
        setLoadingOpen(true);
        var jsonObj = {
            Type: 'APIToken'
        };
        setIsError(false);

        var response = await SEND_OTP(JSON.stringify(jsonObj));

        setLoadingOpen(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (response.data === 'True') {
            setOpenOTP(true);
        }
    };

    const Insert = async (values) => {
        var jsonObj = {
            OTP: values.OTP
        };
        var requestObj = JSON.stringify(jsonObj);

        setIsError(false);

        var response = await INSERT_TOKEN(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            return;
        }
        setOpenOTP(false);
        select();
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                onSubmit={submitHandle}
            >
                {(formProps) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>API Token </h2>
                            <Grid item xs={12} md={12} lg={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={4}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Token"
                                                name="APIToken"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Token"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Mobile Number"
                                                name="MobileNumber"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Token"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <Box
                                                className={classes.flexReverse}
                                            >
                                                <div
                                                    className={
                                                        classes.SubmitWrapper
                                                    }
                                                >
                                                    <Button
                                                        type="submit"
                                                        title="Save"
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        disabled={loadingOpen}
                                                    >
                                                        Generate Token
                                                    </Button>
                                                    {loadingOpen && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    error={modalErrorMessage}
                    submitCallback={(value) => {
                        Insert(value);
                    }}
                    resendCallback={(value) => {}}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
